'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var TRAIT_ORDER_ID = exports.TRAIT_ORDER_ID = 'order_id';
var TRAIT_COUPON_ID = exports.TRAIT_COUPON_ID = 'Coupon ID';
var TRAIT_DISCOUNT = exports.TRAIT_DISCOUNT = 'Discount';
var TRAIT_PRODUCT_ID = exports.TRAIT_PRODUCT_ID = 'product_id';
var TRAIT_PRODUCT_NAME = exports.TRAIT_PRODUCT_NAME = 'product_name';
var TRAIT_PRODUCT_PRICE = exports.TRAIT_PRODUCT_PRICE = 'product_price';
var TRAIT_PRODUCT_CATEGORY = exports.TRAIT_PRODUCT_CATEGORY = 'product_category';
var TRAIT_TOTAL = exports.TRAIT_TOTAL = 'Total';
var TRAIT_NAME = exports.TRAIT_NAME = 'name';
var TRAIT_PRICE = exports.TRAIT_PRICE = 'price';
var TRAIT_AFFILIATION = exports.TRAIT_AFFILIATION = 'affiliation';
var TRAIT_CATEGORY = exports.TRAIT_CATEGORY = 'category';
var TRAIT_QUANTITY = exports.TRAIT_QUANTITY = 'quantity';
var TRAIT_CHECKOUT_ID = exports.TRAIT_CHECKOUT_ID = 'checkout_id';
var TRAIT_PRODUCTS = exports.TRAIT_PRODUCTS = 'products';
var TRAIT_STEP = exports.TRAIT_STEP = 'step';
var TRAIT_LOCATION = exports.TRAIT_LOCATION = 'location';
var TRAIT_SUBSECTION = exports.TRAIT_SUBSECTION = 'subsection';
var TRAIT_POSITION = exports.TRAIT_POSITION = 'position';
var TRAIT_BOOKMAKER = exports.TRAIT_BOOKMAKER = 'bookmaker';
var TRAIT_BOOKMAKER_USERNAME = exports.TRAIT_BOOKMAKER_USERNAME = 'bookmaker_username';
var TRAIT_BOOKMAKER_NAME = exports.TRAIT_BOOKMAKER_NAME = 'bookmaker_name';
var TRAIT_BOOKMAKER_OFFER = exports.TRAIT_BOOKMAKER_OFFER = 'bookmaker_offer';
var TRAIT_BOOKMAKER_TIER = exports.TRAIT_BOOKMAKER_TIER = 'bookmaker_tier';
var TRAIT_OFFERS_BANNER = exports.TRAIT_OFFERS_BANNER = 'offers_banner';
var TRAIT_BOOKMAKER_STATUS = exports.TRAIT_BOOKMAKER_STATUS = 'status';
var TRAIT_PRODUCT = exports.TRAIT_PRODUCT = 'Product';
var TRAIT_CURRENCY = exports.TRAIT_CURRENCY = 'currency';

var TRAIT_ODDS = exports.TRAIT_ODDS = 'odds';
var TRAIT_RACE_ID = exports.TRAIT_RACE_ID = 'race_id';
var TRAIT_RACE_DATE = exports.TRAIT_RACE_DATE = 'race_date';
var TRAIT_RACE_TIME = exports.TRAIT_RACE_TIME = 'race_time';
var TRAIT_RACE_OFFERS_AVAILABLE = exports.TRAIT_RACE_OFFERS_AVAILABLE = 'offer_available';
var TRAIT_TIME_OF_EVENT = exports.TRAIT_TIME_OF_EVENT = 'time_of_event';
var TRAIT_RACECOURSE = exports.TRAIT_RACECOURSE = 'racecourse';
var TRAIT_HORSE_NAME = exports.TRAIT_HORSE_NAME = 'horse_name';
var TRAIT_BET_DATE = exports.TRAIT_BET_DATE = 'bet_date';
var TRAIT_SELECTIONS = exports.TRAIT_SELECTIONS = 'selections';
var TRAIT_BETSLIP_ID = exports.TRAIT_BETSLIP_ID = 'bet_slip_id';
var TRAIT_RECEIPT = exports.TRAIT_RECEIPT = 'bet_receipt';
var TRAIT_RECEIPT_ID = exports.TRAIT_RECEIPT_ID = 'bet_receipt_id';
var TRAIT_RECEIPT_TYPE = exports.TRAIT_RECEIPT_TYPE = 'bet_receipt_type';
var TRAIT_BET_COUNT = exports.TRAIT_BET_COUNT = 'bet_count';
var TRAIT_BET_TYPE = exports.TRAIT_BET_TYPE = 'bet_type';
var TRAIT_STAKE = exports.TRAIT_STAKE = 'stake';
var TRAIT_WIN_EW = exports.TRAIT_WIN_EW = 'win_or_ew';
var TRAIT_API_OUTCOME = exports.TRAIT_API_OUTCOME = 'api_outcome';
var TRAIT_COUPON = exports.TRAIT_COUPON = 'Coupon';
var TRAIT_REVENUE = exports.TRAIT_REVENUE = 'revenue';
var TRAIT_PACKAGE = exports.TRAIT_PACKAGE = 'Package';
var TRAIT_STATUS = exports.TRAIT_STATUS = 'Status';

var TRAIT_REWARDS_FOR_RACING = exports.TRAIT_REWARDS_FOR_RACING = 'Rewards For Racing';
var TRAIT_DAILY_CONTACT = exports.TRAIT_DAILY_CONTACT = 'Daily Contact';
var TRAIT_FIRST_NAME = exports.TRAIT_FIRST_NAME = 'First Name';
var TRAIT_LAST_NAME = exports.TRAIT_LAST_NAME = 'Last Name';
var TRAIT_PHONE_NUMBER = exports.TRAIT_PHONE_NUMBER = 'Phone Number';

var TRAIT_EMAIL = exports.TRAIT_EMAIL = 'Email';
var TRAIT_CREATED_AT = exports.TRAIT_CREATED_AT = 'Created At';
var TRAIT_OUTCOME = exports.TRAIT_OUTCOME = 'Outcome';
var TRAIT_ERROR = exports.TRAIT_ERROR = 'error';

var TRAIT_RACINGPOST_CONTACT = exports.TRAIT_RACINGPOST_CONTACT = 'Racing Post Contact';
var TRAIT_THIRDPARTY_CONTACT = exports.TRAIT_THIRDPARTY_CONTACT = 'Third Party Contact';

var TRAIT_DEVICE_TYPE = exports.TRAIT_DEVICE_TYPE = 'device_type';
var TRAIT_USER_NAME = exports.TRAIT_USER_NAME = 'username';
var TRAIT_USER_ID = exports.TRAIT_USER_ID = 'user_id';
var TRAIT_LOGGED_IN_STATUS = exports.TRAIT_LOGGED_IN_STATUS = 'logged_in_status';
var TRAIT_BETTING_ACCOUNT_LOGGED_IN_STATUS = exports.TRAIT_BETTING_ACCOUNT_LOGGED_IN_STATUS = 'betting_account_logged_in_status';

var TRAIT_PACKAGE_ORIGIN = exports.TRAIT_PACKAGE_ORIGIN = 'Package Origin';
var TRAIT_PACKAGE_DESTINATION = exports.TRAIT_PACKAGE_DESTINATION = 'Package Destination';

var TRAIT_LAST_CHANGED_OPTION = exports.TRAIT_LAST_CHANGED_OPTION = 'last_changed_option';

var TRAIT_RACE_CONDITIONS = exports.TRAIT_RACE_CONDITIONS = 'race_conditions';
var TRAIT_FORM = exports.TRAIT_FORM = 'form';
var TRAIT_MY_NOTES = exports.TRAIT_MY_NOTES = 'my_notes';
var TRAIT_SPOTLIGHTS = exports.TRAIT_SPOTLIGHTS = 'spotlights';
var TRAIT_COMMENTS = exports.TRAIT_COMMENTS = 'comments';
var TRAIT_OWNER = exports.TRAIT_OWNER = 'owner';
var TRAIT_QUOTES = exports.TRAIT_QUOTES = 'quotes';
var TRAIT_PEDIGREES = exports.TRAIT_PEDIGREES = 'pedigrees';
var TRAIT_RTF = exports.TRAIT_RTF = 'rtf%';
var TRAIT_DECIMAL_ODDS = exports.TRAIT_DECIMAL_ODDS = 'decimal_odds';
var TRAIT_PRICE_HISTORY = exports.TRAIT_PRICE_HISTORY = 'price_history';
var TRAIT_ORDER_BY_PRICE = exports.TRAIT_ORDER_BY_PRICE = 'order_by_price';
var TRAIT_BETTING_FORCAST = exports.TRAIT_BETTING_FORCAST = 'betting_forecast';
var TRAIT_MY_RATINGS = exports.TRAIT_MY_RATINGS = 'my_ratings';
var TRAIT_SHOW_PRICES = exports.TRAIT_SHOW_PRICES = 'show_prices';

var TRAIT_HORSE_ENTERED = exports.TRAIT_HORSE_ENTERED = 'Horse Entered';
var TRAIT_HORSE_DECLARED = exports.TRAIT_HORSE_DECLARED = 'Horse Declared';
var TRAIT_SHOW_PEDIGREE = exports.TRAIT_SHOW_PEDIGREE = 'Show Pedigree';

var TRAIT_SELECTION = exports.TRAIT_SELECTION = 'selection';

var TRAIT_SITE_SECTION = exports.TRAIT_SITE_SECTION = 'site_section';
var TRAIT_SITE_SUB_SECTION_1 = exports.TRAIT_SITE_SUB_SECTION_1 = 'site_sub_section_1';
var TRAIT_SITE_SUB_SECTION_2 = exports.TRAIT_SITE_SUB_SECTION_2 = 'site_sub_section_2';
var TRAIT_SITE_SUB_SECTION_3 = exports.TRAIT_SITE_SUB_SECTION_3 = 'site_sub_section_3';

var TRAIT_UK_TIMESTAMP = exports.TRAIT_UK_TIMESTAMP = 'uk_timestamp';

var TRAIT_HORSE_BETTING = exports.TRAIT_HORSE_BETTING = 'Communication Horse Betting';
var TRAIT_HORSE_NEWS = exports.TRAIT_HORSE_NEWS = 'Communication Horse News';
var TRAIT_COMPETITIONS = exports.TRAIT_COMPETITIONS = 'Communication Competitions';
var TRAIT_BLOODSTOCK = exports.TRAIT_BLOODSTOCK = 'Communication Bloodstock';
var TRAIT_SPORT_BETTING = exports.TRAIT_SPORT_BETTING = 'Communication Sport Betting';
var TRAIT_OVER_EIGHTEEN = exports.TRAIT_OVER_EIGHTEEN = 'Communication Eighteen';
var TRAIT_DAYLY_UPDATES = exports.TRAIT_DAYLY_UPDATES = 'Daily Contact';
var TRAIT_R4R = exports.TRAIT_R4R = 'Rewards For Racing';
var TRAIT_THIRD_PARTY = exports.TRAIT_THIRD_PARTY = 'Third Party Contact';
var TRAIT_TS_CS = exports.TRAIT_TS_CS = 'Ts+Cs';
var TRAIT_18_PLUST = exports.TRAIT_18_PLUST = '18+';

var TRAIT_SUBSCRIBER_REWARDS = exports.TRAIT_SUBSCRIBER_REWARDS = 'Subscriber rewards (Members only)';
var TRAIT_MEMBERS_BRIEFING = exports.TRAIT_MEMBERS_BRIEFING = 'Member\'s Briefing (Members only)';
var TRAIT_THE_FRONT_RUNNER = exports.TRAIT_THE_FRONT_RUNNER = 'The Front Runner (Ultimate Members only)';
var TRAIT_THE_ULTIMATE_DAILY = exports.TRAIT_THE_ULTIMATE_DAILY = 'The Ultimate Daily (Ultimate Members only)';

var TRAIT_ACCORDION_NAME = exports.TRAIT_ACCORDION_NAME = 'Accordion Name';
var TRAIT_DISC_NAME = exports.TRAIT_DISC_NAME = 'Disc Name';

var TRAIT_TYPE = exports.TRAIT_TYPE = 'type';

var TRAIT_NUMBER_OF_OFFERS = exports.TRAIT_NUMBER_OF_OFFERS = 'number_of_offers';

var TRAIT_USER_LAST_LOGIN_DATE = exports.TRAIT_USER_LAST_LOGIN_DATE = 'last_logged_in_date_web';
var TRAIT_NUMBER_BOOKMAKERS_ACCOUNTS = exports.TRAIT_NUMBER_BOOKMAKERS_ACCOUNTS = 'bookmaker_accounts_number_web';
var TRAIT_RECENT_BOOKMAKERS = exports.TRAIT_RECENT_BOOKMAKERS = {
    bet365_logged_in_web: false,
    betfair_logged_in_web: false,
    coral_logged_in_web: false,
    ladbrokes_logged_in_web: false,
    paddy_power_logged_in_web: false,
    skybet_logged_in_web: false,
    william_hill_logged_in_web: false
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/traits.js
// module id = 11
// module chunks = 1